import { useEffect, useState } from "react";
import { getShippingCost, calculateTotalPriceWithShippingCost } from "../utils/calculateTotalPriceWithShippingCost";

export function useCartLogic(cart, setCart) {
  const [isLoading, setIsLoading] = useState(true);
  const [showAlertEmpty, setShowAlertEmpty] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [shippingCost, setShippingCost] = useState(0);
  const [totalPriceWithShippingCost, setTotalPriceWithShippingCost] = useState(0);

  // Carrega carrinho do localStorage
  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart"));
    if (storedCart?.length > 0) {
      setCart(storedCart);
    }
    setIsLoading(false);
  }, [setCart]);

  // Salva carrinho no localStorage
  useEffect(() => {
    if (cart.length > 0) {
      localStorage.setItem("cart", JSON.stringify(cart));
    }
  }, [cart]);

  // Calcula preços e frete
  useEffect(() => {
    const getDiscountedPrice = (realPrice, discount) =>
      realPrice * (1 - discount / 100);

    const total = cart.reduce(
      (sum, item) =>
        sum + getDiscountedPrice(item.product.real_price, item.product.discount) * item.quantityInCart,
      0
    );

    const shipping = getShippingCost(total);
    const totalWithShipping = calculateTotalPriceWithShippingCost(total);

    setTotalPrice(total);
    setShippingCost(shipping);
    setTotalPriceWithShippingCost(totalWithShipping);
    setShowAlertEmpty(cart.length === 0);
    setIsLoading(false);
  }, [cart]);

  return {
    isLoading,
    showAlertEmpty,
    setShowAlertEmpty,
    totalPrice,
    shippingCost,
    totalPriceWithShippingCost,
  };
}
